/**
 * Percorso di ritorno dopo il login: solo path relativi allo stesso sito,
 * mai URL esterni o rotte di autenticazione.
 */
export function safeNextPath(value: unknown): string | undefined {
  if (typeof value !== "string") return undefined;
  if (!value.startsWith("/") || value.startsWith("//")) return undefined;
  if (value.startsWith("/auth") || value.startsWith("/onboarding")) return undefined;
  return value;
}
